import React, { createContext } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { w3cwebsocket as WebSocketClient } from 'websocket';
import {
  getLiveCallsData,
  updateLiveCall,
  updateLiveCallIntent,
  updateLiveCallTranscription,
  updateLiveCallTranscriptionIntentOrSentiment
} from 'store/liveCalls';
import useAuthStore from 'hooks/useAuth';

const TAG = 'SOCKET';
const WS_BASE = process.env.REACT_APP_SOCKET_URL;
const WS_BASE_TRANSCRIPTION = process.env.REACT_APP_SOCKET_URL_TRANSCRIPTION;
const WebSocketContext = createContext(null);
const useWebsocket = () => React.useContext(WebSocketContext);

export const EVENTS = {
  live_call_count: 'live_call_count',
  call_data: 'call_data',
  intent: 'intent'
};
export const WSS_EVENTS_FOR_QP = {
  CALL_CONTENT: 'CALL_CONTENT',
  CALL_SENTIMENT: 'CALL_SENTIMENT',
  CALL_INTENT: 'CALL_INTENT'
};
// const getEventType = (data) => {
//   return EVENTS[data.type] ?? null;
// };

export { WebSocketContext, useWebsocket };

const WebSocket = ({ children, user_id, ...props }) => {
  const socket = React.useRef();
  const socketTranscription = React.useRef();
  const { AccessToken } = useAuthStore();
  const {
    getLiveCallsDataAction,
    updateLiveCallAction,
    updateLiveCallTranscription,
    updateLiveCallIntentAction,
    updateLiveCallTranscriptionIntentOrSentimentAction
  } = props;
  //create socket
  const getBaseURL = (token) => {
    const currentLocation = window.location;
    const baseURL = `wss://${currentLocation.hostname}/api/ws/live_call?token=${token}`;
    return baseURL;
  };
  const baseURL = process.env.NODE_ENV === 'production' ? getBaseURL(AccessToken) : WS_BASE + `/api/ws/live_call?token=${AccessToken}`;

  const socketFunc = React.useCallback(() => {
    if (!socket.current) {
      socket.current = new WebSocketClient(baseURL);

      socket.current.onopen = () => {
        console.warn(TAG, 'WebSocket Client Connected => wss://map.servicepack.ai');
      };

      socket.current.onmessage = function (event) {
        var { data, type } = JSON.parse(event.data);
        console.warn(TAG, data, type);
        if (type === EVENTS.live_call_count) {
          //   setSocketJobStatusAction(data);
        } else if (type === EVENTS.call_data) {
          console.warn(TAG, data);
          updateLiveCallAction(data);
          //   setSocketJobDataAction(data);
        } else if (type === EVENTS.intent) {
          updateLiveCallIntentAction(data);
        }
      };

      socket.current.onclose = function (_e) {
        _e;
        console.warn(TAG, 'Connection closed => wss://map.servicepack.ai');
      };
    }
  }, [user_id]);

  const socketFuncTranscription = React.useCallback(async () => {
    await socketFuncTranscriptionDisconnect();
    socketTranscription.current = new WebSocketClient(WS_BASE_TRANSCRIPTION);

    socketTranscription.current.onopen = () => {
      console.warn(TAG, `WebSocket Client Connected =>${WS_BASE_TRANSCRIPTION}`);
    };

    socketTranscription.current.onmessage = function (event) {
      try {
        var { data } = event;
        console.warn(TAG, data, event.data);
        if (data) {
          console.log(event.data, 'socketTranscription');

          var { data: transcriptionData, type } = JSON.parse(event.data);
          console.log('transcriptionData, type', transcriptionData, type);
          if (WSS_EVENTS_FOR_QP.CALL_CONTENT === type) {
            updateLiveCallTranscription(transcriptionData);
          } else {
            updateLiveCallTranscriptionIntentOrSentimentAction(transcriptionData);
          }
        }
      } catch (error) {
        console.log(error);
      }
      // if (getEventType(data) === EVENTS.live_call_count) {
      //   //   setSocketJobStatusAction(data);
      // } else if (getEventType(data) === EVENTS.call_data) {
      //   console.warn(TAG, data);
      //   updateLiveCallAction(data);
      //   //   setSocketJobDataAction(data);
      // }

      socketTranscription.current.onclose = function (_e) {
        _e;
        console.warn(TAG, `Connection closed => ${WS_BASE_TRANSCRIPTION}`);
      };
    };
  }, []);

  // socket disconect
  const socketDisconnect = React.useCallback(() => {
    if (socket.current) {
      socket.current.close();
      socket.current = null;
    } else {
      console.warn(TAG, 'NOT CONNECTED!');
    }
  }, []);

  // socket disconect
  const socketFuncTranscriptionDisconnect = React.useCallback(() => {
    if (socketTranscription.current) {
      socketTranscription.current.close();
      socketTranscription.current = null;
    } else {
      console.warn(TAG, 'NOT CONNECTED!');
    }
  }, []);

  //connection enstablished online offline
  React.useEffect(() => {
    const offline = (_e) => {
      _e;
      console.warn(TAG, 'offline');
      socketDisconnect();
      socketFuncTranscriptionDisconnect();
    };
    window.addEventListener('offline', offline);
    const online = (_e) => {
      _e;
      socketFunc();
      socketFuncTranscription();
      console.warn(TAG, 'online');
    };
    window.addEventListener('online', online);
    socketFunc();
    socketFuncTranscription();
    return () => {
      window.removeEventListener('offline', offline);
      window.removeEventListener('online', online);
    };
  }, [user_id]);

  const ws = React.useMemo(() => {
    return {
      socket: socket,
      socketDisconnect: socketDisconnect,
      socketFuncTranscription
    };
  }, [socket, socketDisconnect, socketFuncTranscription]);

  React.useLayoutEffect(() => {
    const abortController = new AbortController();

    getLiveCallsDataAction({
      signal: abortController.signal,
      // url: 'https://vp-dev.servicepack.ai:8000' + '/api/live-call-data',
      url: 'https://demo.qms.servicepack.ai/api/live_call/desktop-api/live-ongoing-calls/'
    });

    return () => {
      abortController.abort();
    };
  }, [getLiveCallsDataAction]);
  return <WebSocketContext.Provider value={ws}>{children}</WebSocketContext.Provider>;
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateLiveCallTranscription: (params) => dispatch(updateLiveCallTranscription(params)),
    updateLiveCallAction: (params) => dispatch(updateLiveCall(params)),
    getLiveCallsDataAction: (params) => dispatch(getLiveCallsData(params)),
    updateLiveCallIntentAction: (params) => dispatch(updateLiveCallIntent(params)),
    updateLiveCallTranscriptionIntentOrSentimentAction: (params) => dispatch(updateLiveCallTranscriptionIntentOrSentiment(params))
  };
};
WebSocket.propTypes = {
  children: PropTypes.node,
  user_id: PropTypes.number,
  updateLiveCallTranscription: PropTypes.func,
  updateLiveCallAction: PropTypes.func,
  getLiveCallsDataAction: PropTypes.func,
  updateLiveCallIntentAction: PropTypes.func,
  updateLiveCallTranscriptionIntentOrSentimentAction: PropTypes.func
};
export default React.memo(connect(null, mapDispatchToProps)(WebSocket));
